import clsx from "clsx"

export const DateAttribute = ({
    value,
    required,
    placeholder,
    readOnly,
    className,
    onChange,
    onBlur,
}: {
    value?: string,
    required?: boolean,
    placeholder?: string,
    readOnly?: boolean,
    className?: string,
    onChange: (value: any) => void,
    onBlur: () => void
}) => {
    return <>
        <input
            type="date"
            required={required}
            readOnly={readOnly}
            placeholder={placeholder}
            value={value || ''}
            onBlur={() => onBlur()}
            onChange={(e) => onChange(e.target.value)}
            className={clsx(className, 'form-control form-control-sm')} />
    </>
}
